import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import DataGrid from "devextreme-react/ui/data-grid";
import { Column, RemoteOperations, Paging, Pager, Popup } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import {
  setEditTrabajadoresSN,
  doGetDraft,
  setTipoSolicitud,
  loadBorradorAgenda,
  abrirCerrarModalNuevaSolicitud,
  loadDataGrid,
  openCloseModalEliminarSolicitud,
  setCleanSolicitudAgenda,
  loadDataSelected,
  openCloseModalContinue,
  doDeleteDraft,
  setSolicitudesEmpresaFiltrada,
  setCleanDataComplain,
  setShowHideForm
} from "./actions";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import { filterType, filterData } from "../../../../../helpers/filterHelper";
import TableFilter from "../../../../Shared/tableFilter.jsx";
import ModalDraft from "./modalDraft";
import validaciones from "../../../../../helpers/validaciones";
import ModalDocumentos from "../../../Documentos/modalDocumentos";
import moment from "moment";
import enumSolicitudes from "../../Enums/solicitudes";
import ModalEliminarSolicitud from "./modalEliminarSolicitud";
import ModalEliminarBorrador from "./modalEliminarBorrador"
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import UserInfoColumn from "../../../../Shared/UserInfoColumn";
import ModalVer from "../../../../Shared/ModalVer"

class TableAgendamiento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filtersLoaded: false,
      openModalVer: false,
      dataModalVer: null
    };
    this.mainFilter = (_obj) => {
      const _arr = [
        {
          Icon: "2", name: "Borrador de solicitud", column: "estadoSolicitud", value: { text: "borrador", value: 6 },
        },
        {
          Icon: "5", name: "En revisión", column: "estadoSolicitud", value: { text: "revision", value: 1 },
        },
        {
          Icon: "6", name: "Rechazadas por aprobador", column: "estadoSolicitud", value: { text: "rechazado", value: 3 },
        },
        {
          Icon: "0", name: "Aprobadas", column: "estadoSolicitud", value: { text: "aprobado", value: 2 },
        },
        {
          Icon: "6", name: "Rechazadas por ejecutivo", column: "estadoSolicitud", value: { text: "rechazadoCallCenter", value: 9 },
        },
        {
          Icon: "b", name: "Agendadas", column: "estadoSolicitud", value: { text: "agendado", value: 4 },
        },
      ];
      if (_obj) { return _arr.find((e) => e.value.value === _obj.value.value); }
      return _arr;
    };
  }

  componentDidMount = (prevProps) => {
    this.props.dispatch(setSolicitudesEmpresaFiltrada([]));
    if (!this.state.filtersLoaded) {
      // From: 1 año hacia atras
      // to: año actual.
      const data = {
        from: formatDateForFilter(moment().subtract(1, "year")),
        to: formatDateForFilter(moment()),
        companyRut: this.props.companyId,
        PetitionerRut: this.props.userData.RUT,
        StatusId: this.props.selectedTipoSolicitud.value.value,
      };
      this.props.dispatch(loadDataGrid(data));
      this.setState({ filtersLoaded: true });
    }
  }

  componentWillUnmount = () => {
    //this.props.dispatch(setCleanDataComplain())
    this.props.dispatch(setCleanSolicitudAgenda())
    this.props.dispatch(setShowHideForm(false));
  }

  componentDidUpdate = (prev) => {
    if (this.props.selectedSolicitudShow && prev.selectedSolicitudShow !== this.props.selectedSolicitudShow) {
      this.handleModalVer()
    }
  }

  getButton = (row) => {
    if (row.data.EstadoSolicitud === "PENDIENTE") {
      if (row.data.TieneBorrador) {
        return <Button style={{ color: "white", backgroundColor: "#C5BE52" }} text="Borrador" type="normal" className="slimButton" onClick={() => this.getDraftComplain(row)} />;
      }
      return <Button text="Enviar" type="default" className="slimButton" />;
    }
    return <Button text="Reenviar" type="default" className="slimButton" />;
  }

  getDraftComplain = (row) => {
    this.props.dispatch(doGetDraft(this.props.companyId, row.data.RutTrabajador));
  }

  handleNewSolicitud = () => {
    this.props.dispatch(abrirCerrarModalNuevaSolicitud(true));
  }

  handleCorregirSolicitud = (row) => {
    this.props.dispatch(loadBorradorAgenda(row.data.Id, this.props.companyId, null, true));
  }

  doGetComplains = (data) => {
    this.props.dispatch(setSolicitudesEmpresaFiltrada([]));
    const filtros = {
      from: formatDateForFilter(moment().subtract(1, "year")),
      to: formatDateForFilter(moment()),
      companyRut: this.props.companyId,
      PetitionerRut: this.props.userData.RUT,
      StatusId: this.props.selectedTipoSolicitud.value.value,
    };
    if (validaciones.emptyText(this.props.sucursalId)) {
      filtros.idSucursal = this.props.sucursalId;
    }
    this.props.dispatch(loadDataGrid(filtros));
  }

  handleFilterChange = (text, filters) => {
    let currentFilters = [...filters];
    const _estadoSolicitud = currentFilters.find((e) => e.column === "estadoSolicitud");
    if (_estadoSolicitud && this.props.selectedTipoSolicitud.value.value !== _estadoSolicitud.value.value) {
      this.props.dispatch(setTipoSolicitud(this.mainFilter(_estadoSolicitud)));
      this.doGetComplains();
    } else {
      currentFilters = currentFilters.map((e) => e.column !== "estadoSolicitud" ? e : null).filter((e) => e);
      if (text) {
        currentFilters.push({
          column: "Id", filterValue: null, value: { text, value: text }, type: filterType.search,
        });
      }
      const ProposalDate = currentFilters.length > 0 ? currentFilters.filter((f) => f.column === "ProposalDate") : [];
      if (ProposalDate.length > 0) {
        const pivotFecha = ProposalDate.find((i) => i.column === "ProposalDate");
        let FechaDesde = null;

        if (this.state.doFilterProposalDate === true) {
          FechaDesde = this.state.ProposalDate;
        } else {
          FechaDesde = formatDateForFilter(moment().subtract(1, "year"));
        }
        const dateIsBefore = moment(pivotFecha.value.value.from).isBefore(moment(FechaDesde));
        // llamado al api cuando las fechas son menores con respecto a las que mando por primera vez
        if (dateIsBefore === true) {
          const data = {
            from: formatDateForFilter(moment(pivotFecha.value.value.from)),
            to: formatDateForFilter(moment(pivotFecha.value.value.to)),
          };
          this.doGetComplains(data);
          this.setState({
            doFilterProposalDate: true,
            ProposalDate: pivotFecha.value.value.from,
          });
        }
      }
      if (this.state.doFilterProposalDate && ProposalDate.length === 0) {
        // vuelvo a la carga de datos inicial. al limpiar el rango de fecha que fue menor a la orginal
        const data = {
          from: formatDateForFilter(moment().subtract(1, "year")),
          to: formatDateForFilter(moment()),
        };
        this.doGetComplains(data);
        this.setState({
          doFilterProposalDate: false,
          ProposalDate: null,
        });
      }
      let _listaSolicitudes = this.props.listaSolicitudes.map(e => {
        e.CreationDate = moment(e.CreationDate).startOf("day").format();
        return e
      })
      const newData = filterData(_listaSolicitudes, currentFilters);
      if (currentFilters.length > 0) {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(newData));
      } else {
        this.props.dispatch(setSolicitudesEmpresaFiltrada(this.props.listaSolicitudes));
      }
    }
  }

  handleDctos = (link) => {
    window.open(link, "_blank");
  }

  handleViewDocuments = (id) => {
    this.props.dispatch(loadBorradorAgenda(id, this.props.companyId));
  }

  handleSinNombre = (row) => {
    this.props.dispatch(setEditTrabajadoresSN(true));
    this.props.dispatch(loadBorradorAgenda(row.data.Id, this.props.companyId, true));
  }

  handleDeleteRow = (row, valor) => {
    this.deleteRow(row.data, valor);
  }

  async deleteRow(row, valor) {
    const { onOpenModal } = this.props;
    const requestStatus = {
      RequestId: row.Id,
      RequestStatus: valor,
      Comment: "test",
    };
    onOpenModal(true, requestStatus);
  }

  handleModalVer = () => {
    const {
      Pools,
      AdditionalExams,
      PsychologicalExams,
      Workers,
      CompanyName,
      CostCenter,
      PetitionerName,
      PetitionerRut,
      ProposalDate,
      ProposalDateEnd,
      WorkersQuota,
      RequestTypeDescription,
      defaultCityDescription
    } = this.props.selectedSolicitudShow;
    let _data = {};
    const _firstBenefit = [...Pools, ...AdditionalExams, ...PsychologicalExams].find(e => e.AchsOfficeDescription);
    _data.defaultCityDescription = _firstBenefit && _firstBenefit.AchsOfficeDescription ? _firstBenefit.AchsOfficeDescription : "";
    const baterias = Pools ? [{ key: `Baterías (${Pools.length})`, items: Pools.map((e) => e.Description) }] : [];
    const examenes = AdditionalExams ? [{ key: `Prestaciones médicas (${AdditionalExams.length})`, items: AdditionalExams.map((e) => e.ExamDescription) }] : [];
    const psicologicos = PsychologicalExams ? [{ key: `Evaluaciones psicológicas (${PsychologicalExams.length})`, items: PsychologicalExams.map((e) => e.ExamDescription) }] : [];
    _data.benefits = [...baterias, ...examenes, ...psicologicos];
    _data.workers = Workers ? Workers : [];
    _data.info = {
      CompanyName: CompanyName ? CompanyName : "",
      CostCenter: CostCenter ? CostCenter : "",
      PetitionerName: PetitionerName ? PetitionerName : "",
      PetitionerRut: PetitionerRut ? PetitionerRut : "",
      ProposalDate: ProposalDate ? ProposalDate : "",
      ProposalDateEnd: ProposalDateEnd ? ProposalDateEnd : "",
      WorkersQuota: WorkersQuota ? WorkersQuota : "",
      RequestTypeDescription: RequestTypeDescription ? RequestTypeDescription : "",
      defaultCityDescription: defaultCityDescription ? defaultCityDescription : ""
    }
    this.setState({ openModalVer: true, dataModalVer: _data })
  }

  openModalVer = (row) => {
    this.props.dispatch(loadDataSelected(row.Id, true));
  }

  closeModalVer = () => {
    this.setState({ openModalVer: false, dataModalVer: null })
  }

  renderSolicitudesDataGrid() {
    const {
      selectedTipoSolicitud,
    } = this.props;
    const textStatus = selectedTipoSolicitud.value && selectedTipoSolicitud.value.text ? selectedTipoSolicitud.value.text : null;
    const columns = () => {
      const _columns = [];
      _columns.push(
        {
          caption: "N° de Solicitud",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Aprobador",
          allowSearch: true,
          alignment: "left",
        }
      );
      switch (textStatus) {
        case "aprobado": case "rechazado": case "rechazadoCallCenter":
          _columns.push({
            caption: "Fecha de envío",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          });
          if (textStatus === "aprobado") {
            _columns.push({
              caption: "Fecha de aprobación",
              allowSearch: true,
              alignment: "center",
              dataType: "date",
              format: "dd/MM/yyyy",
            });
          }
          if (textStatus === "rechazado" || textStatus === "rechazadoCallCenter") {
            _columns.push({
              caption: "Fecha de rechazo",
              allowSearch: true,
              alignment: "center",
              dataType: "date",
              format: "dd/MM/yyyy",
            });
          }
          break;
        case "revision":
          _columns.push({
            caption: "Fecha de envío",
            allowSearch: true,
            alignment: "center",
            dataType: "date",
            format: "dd/MM/yyyy",
          });
          break;
        default:
          break;
      }
      _columns.push(
        {
          caption: "Cantidad de trabajadores",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Tipo de evaluación",
          allowSearch: true,
          alignment: "center",
        },
        {
          caption: "Baterías/Prestaciones",
          allowSearch: true,
          alignment: "center",
        }
      );
      switch (textStatus) {
        case "aprobado":
          _columns.push({
            caption: "Cupos sin nombre",
            alignment: "center",
          });
          break;
        case "borrador": case "revision":
          _columns.push({
            caption: "",
            allowSearch: true,
            alignment: "center",
          });
          break;
        default:
          break;
      }
      if (textStatus !== "borrador") {
        _columns.push({
          caption: "",
          allowSearch: true,
          alignment: "center",
        });
      }
      return _columns;
    };
    const DataRow = (rowInfo) => {
      const _data = rowInfo.data ? rowInfo.data : null;
      return (<tbody className="dx-row">
        <tr className="main-row">
          <td style={{ textAlign: "center" }}>
            {_data.Id ? _data.Id : ""}
          </td>
          <td>
            <UserInfoColumn
              nombre={_data.AuthorizedName ? _data.AuthorizedName : ""}
              rut={_data.AuthorizedRut ? _data.AuthorizedRut : ""}
            />
          </td>
          {((textStatus === "aprobado") ||
            (textStatus === "rechazado") || (textStatus === "rechazadoCallCenter")) &&
            <td style={{ textAlign: "center" }}>
              {_data.CreationDate ? moment(_data.CreationDate).format("L") : ""}
            </td>
          }
          {(textStatus === "aprobado") &&
            <td style={{ textAlign: "center" }}>{_data.ApprovalDate ? moment(_data.ApprovalDate).format("L") : ""}</td>
          }
          {(textStatus === "rechazado") &&
            <td style={{ textAlign: "center" }}>{_data.RejectDate ? moment(_data.RejectDate).format("L") : ""}</td>
          }
          {(textStatus === "rechazadoCallCenter") &&
            <td style={{ textAlign: "center" }}>{_data.RejectCallCenterDate ? moment(_data.RejectCallCenterDate).format("L") : ""}</td>
          }
          {(textStatus === "revision") &&
            <td style={{ fontWeight: "bold", textAlign: "center" }}>{_data.SendDate ? moment(_data.SendDate).format("L") : ""}</td>
          }
          <td style={{ textAlign: "center" }}>{_data.WorkersQuota ? _data.WorkersQuota : "0"}</td>
          <td style={{ textAlign: "center" }}>{_data.RequestTypeDescription ? _data.RequestTypeDescription : ""}</td>
          <td style={{ textAlign: "center" }}>{_data.Content ? _data.Content : ""}</td>
          {(textStatus === "aprobado") &&
            <td style={{ textAlign: "center" }}>
              {_data.WorkersPending && <div
                onClick={() => this.handleSinNombre(rowInfo)}
                className="linkTrabajadoresSN"
              >{_data.WorkersPending ? _data.WorkersPending : ""} sin nombre
              </div>
              }
            </td>
          }
          {(textStatus === "borrador") &&
            <td style={{ textAlign: "right" }}>
              <Button
                text="Borrador"
                type="success"
                className="slimButton"
                //onClick={() => this.handleViewDocuments(rowInfo.data.Id)}
                onClick={() => this.props.dispatch(openCloseModalContinue(true, rowInfo.data.Id))}
              />
            </td>
          }
          {(textStatus === "revision") &&
            <td style={{ textAlign: "right" }}>
              <Button
                text="Eliminar"
                className="delete-button-outline slimButton"
                onClick={() => this.handleDeleteRow(rowInfo, enumSolicitudes.Rechazado)}
              />
            </td>
          }
          {(textStatus !== "borrador") &&
            <td style={{ textAlign: "right" }}>
              <Button
                text="Ver"
                type="success"
                className="slimButton"
                //disabled={(_data.StatusId === 10)}
                onClick={() => this.openModalVer(_data)}
              />
            </td>
          }
        </tr>
        {(textStatus === "rechazado" || textStatus === "rechazadoCallCenter") &&
          <tr className="notes-row">
            <td colSpan="6">
              <div className="row">
                <div className="col-2" style={{ fontWeight: "bold" }}>Comentario:</div>
                <div className="col-10">{_data.RejectComment}</div>
              </div>
            </td>
            <td>
              <Button
                text="Corregir"
                type="success"
                className="slimButton"
                style={{ float: "right" }}
                onClick={() => this.handleCorregirSolicitud(rowInfo)}
              />
            </td>
            <td style={{ textAlign: "right" }}>
              <Button
                text="Eliminar"
                className="delete-button-outline slimButton"
                onClick={() => this.handleDeleteRow(rowInfo, enumSolicitudes.Eliminado)}
              />
            </td>
          </tr>
        }
      </tbody>);
    };
    return (
      <React.Fragment>
        {this.state.loading && <LoadingOverlay />}
        <DataGrid
          dataSource={this.props.listaSolicitudesFiltrada}
          onRowPrepared={this.heightRow}
          showBorders={false}
          showColumnLines={false}
          showRowLines={false}
          noDataText=""
          className="custom-table agendamiento"
          rowAlternationEnabled
          hoverStateEnabled={false}
          activeStateEnabled={false}
          focusStateEnabled={false}
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin solicitudes");
              noDataSpan.appendChild(element);
            }
          }}
          loadPanel={{
            enabled: true,
            showPane: true,
            showIndicator: true,
            indicatorSrc: LoadingGif,
            text: "Cargando...",
          }}
          rowComponent={DataRow}
          columns={columns()}
        >
          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />
          <Paging
            defaultPageSize={10}
          />
          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />
        </DataGrid>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <ModalDocumentos />
        <ModalVer
          data={this.state.dataModalVer}
          isOpen={this.state.openModalVer}
          close={this.closeModalVer}
        />

        <div className="table-wrapper">
          <ModalEliminarBorrador />
          <ModalEliminarSolicitud />
          <TableFilter
            placeholder="Buscar solicitud"
            onChange={this.handleFilterChange}
            filters={this.props.filtrosSolicitudes}
            // show={this.props.listaSolicitudes != null}
            show
            buttons={
              {
                filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
                document: null,
                download: { buttonName: "iconDownload", visible: false, buttonAction: null },
                newItem: {
                  buttonName: "custom", visible: true, buttonAction: this.handleNewSolicitud, buttonText: "Nueva solicitud",
                },
              }
            }
            selectedMainFilter={this.props.selectedTipoSolicitud}
            mainFilter={this.mainFilter()}
          />
          {this.renderSolicitudesDataGrid()}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  listaSolicitudes: state.solicitudesAgendaSel.listaSolicitudes,
  listaSolicitudesFiltrada: state.solicitudesAgendaSel.listaSolicitudesFiltrada,
  filtrosSolicitudes: state.solicitudesAgendaSel.filtrosSolicitudes,
  selectedTipoSolicitud: state.solicitudesAgendaSel.selectedTipoSolicitud,
  shouldUpdateDataGrid: state.solicitudesAgendaSel.shouldUpdateDataGrid,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  selectedSolicitudShow: state.solicitudesAgendaSel.selectedSolicitudShow,
  isOpenModalContinue: state.solicitudesAgendaSel.isOpenModalContinue,
  idSelected: state.solicitudesAgendaSel.idSelected
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
  onOpenModal: (isOpen, request) => dispatch(openCloseModalEliminarSolicitud(isOpen, request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableAgendamiento);
